module.exports = __webpack_public_path__ + "img/ls_type_nac.66014b60.png";